/* eslint-disable react/jsx-no-comment-textnodes */
import { FC, useEffect } from 'react';
import { Paper, Grid, Button, TextField, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useStyles } from './styles';
import { observer } from 'mobx-react-lite';
import { Controller, useForm } from 'react-hook-form';
import { useStore } from 'hooks/useRootStore';
import odic from '../../../assets/odic.png';

export const OdicInfoTable: FC = observer(() => {
  const classes = useStyles();
  const { control, handleSubmit, reset } = useForm<any>();
  const {
    odicStore,
    notificationStore: { openNotification },
  } = useStore();
  const onSubmit = async (data: any) => {
    if (data.organisation) {
      try {
        await odicStore.refreshAfterSave(data.organisation);
        openNotification('success', 'Redirect URI saved successfully!');
        reset(); // Clear the form after successful save
      } catch (error: any) {
        const errorMessage = error.response?.data?.message || 'Failed to save redirect URI';
        openNotification('error', errorMessage);
      }
    }
  };

  const handleDelete = async (uri: string) => {
    try {
      await odicStore.refreshAfterDelete(uri);
      openNotification('success', 'Redirect URI deleted successfully!');
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'Failed to delete redirect URI';
      openNotification('error', errorMessage);
    }
  };

  useEffect(() => {
    document.title = 'EasyIdentity: Odic-InfoDetail';
    odicStore.fetchCredentials().catch(() => {
      openNotification('error', 'Failed to fetch OIDC credentials');
    });
  }, [odicStore, openNotification]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Paper className={classes.paper}>
        <div className={classes.leftCol}>
          <Grid item xs={12} className={classes.btnContainer}>
            <Button className={classes.submitBtn} type='submit' variant='contained'>
              Save changes
            </Button>
          </Grid>
        </div>
        {/* <p className={classes.boxTitle}>All Organisation</p> */}
        <Grid className={classes.row} container justify='space-between'>
          {odicStore.existingRedirectUris.length > 0 && (
            <div style={{ width: '100%', marginBottom: '20px' }}>
              <h5>Existing Redirect URLs:</h5>
              {odicStore.existingRedirectUris.map((uri: string, index: number) => (
                <div
                  key={index}
                  style={{
                    padding: '8px 12px',
                    backgroundColor: '#f5f5f5',
                    margin: '4px 0',
                    borderRadius: '4px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span>{uri}</span>
                  <IconButton size='small' onClick={() => handleDelete(uri)} style={{ color: '#f44336' }}>
                    <Close fontSize='small' />
                  </IconButton>
                </div>
              ))}
            </div>
          )}
          <Controller
            name='organisation'
            control={control}
            render={({ field: { onChange, value, ref } }) => (
              <TextField
                variant='outlined'
                inputRef={ref}
                value={value || ''}
                onChange={onChange}
                className={classes.input}
                label='New Redirect Url'
                placeholder='https://example.com/callback'
                helperText='Enter a valid URL starting with https://'
              />
            )}
          />
        </Grid>
        <div style={{ marginTop: '20px' }}>
          <h5 style={{ marginBottom: '16px' }}>Google Workspace OIDC Configuration & Management Links</h5>
        </div>
        <a href='https://admin.google.com/ac/security/sso'>https://admin.google.com/ac/security/sso</a>
        {/* {!syncDepartmentReq.isFetching && allsyncDepartmentsView.length === 0 && ( */}
        <div style={{ marginTop: '20px' }}>
          <h5 style={{ marginBottom: '16px' }}>How to Configure Google Workspace OIDC SSO with EasyIdentity</h5>
        </div>
        {/* )} */}
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <img
            src={odic}
            alt='odic third party access screenshot'
            style={{ maxWidth: '100%', height: 'auto', border: '1px solid #ddd', borderRadius: '4px' }}
          />
        </div>
      </Paper>
    </form>
  );
});
